import {createSelector} from 'reselect';
import {EventlogState, Event} from "./EventlogState";
import {Association} from "../../../integration/representation/association";

const stateEvents = (state: EventlogState) => state.events;
const stateFetchingEvents = (state: EventlogState) => state.fetchingEvents;
const stateSearchFilter = (state: EventlogState) => state.searchFilter;
const stateFromDateFilter = (state: EventlogState) => state.fromDateFilter;
const stateToDateFilter = (state: EventlogState) => state.toDateFilter;
const stateSinceLastLoginFilter = (state: EventlogState) => state.sinceLastLoginFilter;
const stateCurrentUser = (state: EventlogState) => state.currentUser;
const stateFeatures = (state: EventlogState) => state.features;
const stateFetchingFeatures = (state: EventlogState) => state.fetchingFeatures;
const stateAssociations = (state: EventlogState) => state.associations;
const stateFetchingAssociations = (state: EventlogState) => state.fetchingAssociations;
const stateMilestones = (state: EventlogState) => state.milestones;
const stateFetchingContract = (state: EventlogState) => state.fetchingContract;
const stateFeatureTypeSummary = (state: EventlogState) => state.featureTypeSummary;
const stateFetchingFeatureTypeSummary = (state: EventlogState) => state.fetchingFeatureTypeSummary;
const stateComments = (state: EventlogState) => state.comments;
const stateFeatureTypeIssues = (state: EventlogState) => state.featureTypeIssues;
const stateFeatureTypeComments = (state: EventlogState) => state.featureTypeComments;
const stateFkbFeatures = (state: EventlogState) => state.fkbFeatures;
const stateFetchingFkbFeatures = (state: EventlogState) => state.fetchingFkbFeatures;
const stateNvdbSubmissions = (state: EventlogState) => state.nvdbSubmissions;
const stateFetchingNvdbSubmissions = (state: EventlogState) => state.fetchingNvdbSubmissions;

export const searchFilter = createSelector(
    [stateSearchFilter],
    (searchFilter) => {
        return searchFilter;
    }
);

export const fromDateFilter = createSelector(
    [stateFromDateFilter],
    (fromDateFilter) => {
        return fromDateFilter;
    }
);

export const toDateFilter = createSelector(
    [stateToDateFilter],
    (toDateFilter) => {
        return toDateFilter;
    }
);

export const sinceLastLoginFilter = createSelector(
    [stateSinceLastLoginFilter],
    (sinceLastLoginFilter) => {
        return sinceLastLoginFilter;
    }
);

export const events = createSelector(
    [stateEvents],
    (events) => {
        return events;
    }
);

export const fetchingEvents = createSelector(
    [stateFetchingEvents],
    (fetchingEvents) => {
        return fetchingEvents;
    }
);

export const features = createSelector(
    [stateFeatures],
    (features) => {
        return features;
    }
);

export const fetchingFeatures = createSelector(
    [stateFetchingFeatures],
    (fetchingFeatures) => {
        return fetchingFeatures;
    }
);

export const associations = createSelector(
    [stateAssociations],
    (associations) => {
        return associations;
    }
);

export const fetchingAssociations = createSelector(
    [stateFetchingAssociations],
    (fetchingAssociations) => {
        return fetchingAssociations;
    }
);

export const milestones = createSelector(
    [stateMilestones],
    (milestones) => {
        return milestones;
    }
);

export const fetchingContract = createSelector(
    [stateFetchingContract],
    (fetchingContract) => {
        return fetchingContract;
    }
);

export const featureTypeSummary = createSelector(
    [stateFeatureTypeSummary],
    (featureTypeSummary) => {
        return featureTypeSummary;
    }
);

export const fetchingFeatureTypeSummary = createSelector(
    [stateFetchingFeatureTypeSummary],
    (fetchingFeatureTypeSummary) => {
        return fetchingFeatureTypeSummary;
    }
);

export const comments = createSelector(
    [stateComments],
    (comments) => {
        return comments;
    }
);

export const featureTypeIssues = createSelector(
    [stateFeatureTypeIssues],
    (featureTypeIssues) => {
        return featureTypeIssues;
    }
);

export const featureTypeComments = createSelector(
    [stateFeatureTypeComments],
    (featureTypeComments) => {
        return featureTypeComments;
    }
);

export const fkbFeatures = createSelector(
    [stateFkbFeatures],
    (fkbFeatures) => {
        return fkbFeatures;
    }
);

export const fetchingFkbFeatures = createSelector(
    [stateFetchingFkbFeatures],
    (fetchingFkbFeatures) => {
        return fetchingFkbFeatures;
    }
);

export const nvdbSubmissions = createSelector(
    [stateNvdbSubmissions],
    (nvdbSubmissions) => {
        return nvdbSubmissions;
    }
);

export const fetchingNvdbSubmissions = createSelector(
    [stateFetchingNvdbSubmissions],
    (fetchingNvdbSubmissions) => {
        return fetchingNvdbSubmissions;
    }
);

export const currentUser = createSelector(
    [stateCurrentUser],
    (currentUser) => {
        return currentUser;
    }
);

const getEventsInDescendingOrder = createSelector(
    [stateEvents],
    (events) => {
        let _ = require("lodash");
        return _.orderBy(events, 'occurredInstant').reverse();
    }
);

const getEventsWithAssociationName = createSelector(
    [getEventsInDescendingOrder, stateAssociations],
    (events, associations) => {
        associations.forEach((association: Association) => {
            events.forEach((event: Event) => {
                if (association.id == event.object) {
                    event.object = "Mor: " + association.parentFeature + ", Datter: " + association.childFeature;
                }
            })
        })
        return events;
    }
);

const getEventsWithComments = createSelector(
    [getEventsWithAssociationName, stateFeatures],
    (events, features) => {
        features.forEach(feature => {
            feature.comments.forEach(comment => {
                events.forEach((event: Event) => {
                    if ((event.objectType == "Comment") && (event.object == comment.id)) {
                        event.object = feature.name;
                    }
                })
            })
        })
        return events;
    }
);

const getEventsWithStatusComments = createSelector(
    [getEventsWithComments, stateComments],
    (events, statusComments) => {
        events.forEach((event: Event) => {
            statusComments.forEach(comment => {
                if (event.object == comment.id) {
                    event.object = "Leveransestatuskommentar";
                }
            })
        })
        return events;
    }
);

const getEventsWithFkbComments = createSelector(
    [getEventsWithStatusComments, stateFkbFeatures],
    (events, fkbFeatures) => {
        fkbFeatures.forEach(fkbFeature => {
            fkbFeature.comments.forEach(comment => {
                events.forEach((event: Event) => {
                    if (event.object == comment.id) {
                        event.object = fkbFeature.name;
                    }
                })
            })
        })
        return events;
    }
);

const getEventsWithMilestones = createSelector(
    [getEventsWithFkbComments, stateMilestones],
    (events, milestones) => {
        milestones.forEach(milestone => {
            events.forEach((event: Event) => {
                if ((event.objectType == "ContractMilestone") && (event.object == milestone.id)) {
                    event.object = milestone.name;
                    event.data = milestone.approved ? milestone.description + " (Godkjent)" : milestone.description;
                }
            })
        })
        return events;
    }
);

const getEventsWithFeatureTypeComments = createSelector(
    [getEventsWithMilestones, stateFeatureTypeComments],
    (events, featureTypeComments) => {
        events.forEach((event: Event) => {
            for (var key in featureTypeComments) {
                var featureTypeComment = featureTypeComments[key];
                featureTypeComment.forEach(comment => {
                    if (event.object == comment.id) {
                        event.object = comment.objectId;
                    }
                })
            }
        })
        return events;
    }
);

const getEventsWithFeatureNameForLockedObjects = createSelector(
    [getEventsWithFeatureTypeComments, stateFeatureTypeSummary],
    (events, featureTypeSummary) => {
        events.forEach((event: Event) => {
            featureTypeSummary.forEach(feature => {
                if ((event.objectType == "Lock") || (event.objectType == "Comment")) {
                    let nvdbId = parseInt(event.object.slice(5));
                    if (nvdbId == feature.typeid) {
                        event.object = feature.name;
                    }
                }
            })
        })
        return events;
    }
);

const getEventsWithFeatureTypeIssues = createSelector(
    [getEventsWithFeatureNameForLockedObjects, stateFeatureTypeIssues],
    (events, featureTypeIssues) => {
        events.forEach((event: Event) => {
            for (var key in featureTypeIssues) {
                var featureTypeIssue = featureTypeIssues[key];
                featureTypeIssue.forEach(issue => {
                    if (event.object == issue.id) {
                        event.object = issue.location.featureAlias;
                    }
                })
            }
        })
        return events;
    }
);

const getEventsWithValidationIssue = createSelector(
    [getEventsWithFeatureTypeIssues, stateFeatures],
    (events, features) => {
        events.forEach((event: Event) => {
            features.forEach(feature => {
                if (feature.issues) {
                    feature.issues.forEach(issue => {
                        if (event.object == issue.id) {
                            event.object = feature.name;
                        }
                    })
                }
            })
        })
        return events;
    }
);

const getEventsWithFeatureName = createSelector(
    [getEventsWithValidationIssue, stateFeatures],
    (events, features) => {
        let deletedElements: string[] = [];
        features.forEach(feature => {
            events.forEach((event: Event) => {
                if (event.object.indexOf(feature.id) != -1) {
                    event.object = feature.name;
                }
                else if (event.eventType == "DELETE") {
                    deletedElements.push(event.object);
                    event.object = "Slettet element";
                }
                else if (deletedElements.includes(event.object)) {
                    event.object = "Slettet element";
                }
                else if ((event.objectType == "Contract") || event.objectType == "Features") {
                    event.object = "Denne kontrakten";
                }
                else if (event.objectType == "File") {
                    event.object = event.data.slice(24);
                }
            })
        })
        return events;
    }
);

const getEventsWithNvdbSubmissionStatus = createSelector(
    [getEventsWithFeatureName, stateNvdbSubmissions],
    (events, submissions) => {
        events.forEach((event: Event) => {
            submissions.forEach(submission => {
                if ((event.objectType == "NvdbSubmission")) {
                    let eventDate = event.occurredInstant;
                    let eventISODate = new Date(eventDate.getTime() - (eventDate.getTimezoneOffset() * 60000)).toISOString().split(".")[0];
                    if (submission.created == eventISODate) {
                        event.data = submission.status + ": " + submission.result;
                    }
                }
            })
        })
        return events;
    }
);

const getEventsFilteredBySearch = createSelector(
    [getEventsWithNvdbSubmissionStatus, stateSearchFilter],
    (events, searchFilter) => {
        return events.filter((event: Event) => event.eventType.toLowerCase().indexOf(searchFilter.toLowerCase()) != -1
            || event.objectType.toLowerCase().indexOf(searchFilter.toLowerCase()) != -1
            || event.userId.toLowerCase().indexOf(searchFilter.toLowerCase()) != -1
            || event.object.toLowerCase().indexOf(searchFilter.toLowerCase()) != -1)
    }
);

const getEventsAfterLastLogin = createSelector(
    [stateCurrentUser, getEventsFilteredBySearch],
    (currentUser, events) => {
        if (currentUser) {
            let lastLogin = currentUser.lastLogin;
            let eventsAfterLastLogin = events.filter((event: Event) =>
                event.occurredInstant > lastLogin
            );
            return eventsAfterLastLogin;
        }
        else {
            return events;
        }
    }
);

const getEventsFilteredByDate = createSelector(
    [getEventsFilteredBySearch, stateFromDateFilter, stateToDateFilter],
    (events, fromDateFilter, toDateFilter) => {
        return events.filter((event: Event) => {
            let timezoneOffset = (new Date().getTimezoneOffset() / 60) * (-1);
            let occurredInstantMidnight = new Date(new Date(event.occurredInstant).setHours(timezoneOffset,0,0,0));
            if ((fromDateFilter == null) || (toDateFilter == null)) {
                return event;
            }
            else {
                return (occurredInstantMidnight <= toDateFilter && occurredInstantMidnight >= fromDateFilter)
            }
        })
    }
);

export const getFilteredEvents = createSelector(
    [getEventsAfterLastLogin, getEventsFilteredByDate, stateSinceLastLoginFilter],
    (eventsAfterLastLogin, eventsFilteredByDate, sinceLastLoginFilter) => {
        if (sinceLastLoginFilter) {
            return eventsAfterLastLogin;
        }
        else {
            return eventsFilteredByDate;
        }
    }
);